import React, { useEffect, useState } from "react";
import "./listBox.css";

const ListBoxLocal = ({ items, activeIndex }) => {
  const [currentIndex, setCurrentIndex] = useState(
    activeIndex < items.length ? activeIndex : 0
  );

  useEffect(() => {
    if (activeIndex >= items.length || activeIndex < 0) {
      //  Reset activeIndex to 0 if out of bounds.
      setCurrentIndex(0);
    } else {
      //  Set to activeIndex if within bounds.
      setCurrentIndex(activeIndex);
    }
  }, [activeIndex, items.length]);

  return (
    <div className="listBoxContainer">
      {items.length === 0 ? (
        <div className="emptyMessage">No items available</div>
      ) : (
        <ul className="listBoxList">
          {items.map((item, index) => (
            <li
              className={`listBoxItem ${index === currentIndex ? "activeItem" : ""}`}
              key={index}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ListBoxLocal;
